export default "__VITE_ASSET__D2EtAEy9__"